import { render, staticRenderFns } from "./HealthCheckTable.vue?vue&type=template&id=23255609"
import script from "./HealthCheckTable.vue?vue&type=script&lang=ts"
export * from "./HealthCheckTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports